/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * November 2022
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import NbioApi from "../../lib/api/NbioApi";
import BootstrapTable from "react-bootstrap-table-next";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from 'react-bootstrap/Spinner'
import Badge from "react-bootstrap/Badge";
import NPPaginator from "../ui/NPPaginator";
import SortBtns from "../ui/SortBtns";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import API from "../../lib/api/NbioApi";
import CreateRouteModal from "./CreateRouteModal";

//const
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);

class Routes extends React.Component {
    constructor(p) {
        super(p);
        this.state      = {
            routes: [],
            pages: 1,
            currentPage: 1,
            isLoading: true,
            activeStatusFilter: "",
            activeSort: "newest",
            assignedOperator: "",
            operators: [],
            showCreateRouteModal: false
        }
        this.loadRoutes                 = this.loadRoutes.bind(this);
        this.onStatusFilterChanged      = this.onStatusFilterChanged.bind(this);
        this.onPageChanged              = this.onPageChanged.bind(this);
        this.onSortChanged              = this.onSortChanged.bind(this);
        this.getOperators               = this.getOperators.bind(this);
        this.onAssignOperatorChanged    = this.onAssignOperatorChanged.bind(this);
        this.onRouteCreated             = this.onRouteCreated.bind(this);
    }

    componentDidMount() {
        this.loadRoutes();
        this.getOperators();
    }

    onPageChanged(page) {
        this.setState({currentPage: page}, () => {
            this.loadRoutes();
        })
    }

    loadRoutes() {
        const pageSize    = 50;
        this.setState({isLoading: true});
        NbioApi.routes.getRoutes(
            this.state.currentPage,
            pageSize,
            this.state.activeStatusFilter,
            this.state.activeSort,
            this.state.assignedOperator).then(res => {
                this.setState({
                    routes: res.data.routes,
                    page: res.data.page,
                    pages: res.data.pages,
                    isLoading: false,
                });
        }).catch((ex) => {
        })
    }

    getOperators() {
        API.users.getUsers('operator').then((res) => {
            this.setState({
                operators: res.data.users
            })
        }).catch((ex) => {
        })
    }

    renderStatus(status) {
        if (status === 'open') {
            return <Badge bg={'primary'}>Abierta</Badge>
        } else if (status === 'on_route') {
            return <Badge bg={'warning'}>En ruta</Badge>
        } else if (status === 'finished') {
            return <Badge bg={'success'}>Terminada</Badge>
        } else {
            return <Badge>{status}</Badge>
        }
    }

    onStatusFilterChanged(value){
        this.setState({activeStatusFilter: value}, () => {
            this.loadRoutes();
        });
    }

    onSortChanged(value){
        this.setState({activeSort: value}, () => {
            this.loadRoutes();
        });
    }

    onAssignOperatorChanged(operatorId){
        this.setState({assignedOperator: operatorId}, () => {
            this.loadRoutes();
        });
    }

    onRouteCreated(routeCreated){
        this.setState({showCreateRouteModal:false}, () => {
            this.props.history.push(`/routes/${routeCreated?._id}`)
        })
    }
    humanizeTime(ms){
        return `${new Date(ms).toISOString().slice(11, 19)}`
    }
    render() {
        const routes  = this.state.routes;
        const operators = this.state.operators || [];
        const columns = [
            {
                dataField: 'name',
                text: 'Nombre',
                sort: true,
                sortCaret: (order) => {
                    return <SortBtns order={order}/>
                },
                formatter: (value, row) => {
                    return (
                        <a href={`/routes/${row._id}`}>{value}</a>
                    )
                },
            },
            {
                dataField: 'pois',
                text: 'Núm. de puntos',
                sort: true,
                sortCaret: (order) => {
                    return <SortBtns order={order}/>
                },
                formatter: (value, row) => {
                    const count = value.length;
                    return count;
                }
            },
            {
                dataField: 'status',
                text: 'Estado',
                sort: true,
                sortCaret: (order) => {
                    return <SortBtns order={order}/>
                },
                formatter: (value, row) => {
                    return this.renderStatus(value);
                }
            },
            {
                dataField: 'created_at',
                text: 'Fecha de creación',
                sortCaret: (order) => {
                    return <SortBtns order={order}/>
                },
                formatter: (value, row) => {
                    if (value) {
                        return dayjs(value).format('DD-MM-YY')
                    }
                }
            },
            {
                dataField: 'startedAt',
                text: 'Hora de inicio',
                formatter: (value, row) => {
                    if (value) {
                        return dayjs(value).format('DD-MM-YYYY HH:MM')
                    }
                }
            },
            {
                dataField: 'finishedAt',
                text: 'Hora de finalización',
                formatter: (value, row) => {
                    if (value) {
                        return dayjs(value).format('DD-MM-YYYY HH:MM')
                    }
                }
            },
            {
                dataField: 'extraTime',
                text: 'Tiempo Extra',
                formatter: (value, row) => {
                    if (value) {
                        return this.humanizeTime(value);
                    }
                }
            },
            {
                dataField: 'assignedUser',
                text: 'Operador',
                sort: true,
                sortCaret: (order) => {
                    return <SortBtns order={order}/>
                },
                formatter: (value, row) => {
                    const assignedUser = value;
                    if(!assignedUser){
                        return 'Sin operador';
                    }else{
                        return `${assignedUser.name} ${assignedUser.last_name}`;
                    }
                }
            },
        ];
        return (
            <Container style={{overflowY: "scroll"}} className={'h-100'}>
                <CreateRouteModal show={this.state.showCreateRouteModal}
                                  onRouteCreated={(routeCreated) => this.onRouteCreated(routeCreated)}
                                  onRouteCreationFailed={() => this.setState({showCreateRouteModal:false})}
                                  onRouteCreationCanceled={() => this.setState({showCreateRouteModal:false})}/>
                <Row>
                    <Col className='py-3 d-flex flex-row align-items-center'>
                        <h5 className={'text-capitalize mr-auto'}>Rutas</h5>
                        {/*Note: Old code to create route: */}
                        {/*this.props.history.push('/routes/create')*/}
                        <Button variant="primary"
                                onClick={() => this.setState({showCreateRouteModal:true})}>
                            Crear ruta
                        </Button>
                    </Col>
                </Row>

                <Row className={'my-3'}>
                    <Col md={4} xl={5}></Col>
                    <Col md={6} xl={7} className={'d-flex justify-content-end align-items-center'}>
                        <ButtonToolbar aria-label="Routes toolbar with button groups">
                            {/*Sort*/}
                            <ButtonGroup aria-label="Routes group">
                                <Dropdown as={ButtonGroup}>
                                    <Dropdown.Toggle variant="complementary" id="dropdown-sort-routes">
                                        Ordenar por &nbsp;
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.onSortChanged('newest')}
                                                       active={this.state.activeSort === 'newest'}>
                                            Más recientes
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onSortChanged('oldest')}
                                                       active={this.state.activeSort === 'oldest'}>
                                            Menos recientes
                                        </Dropdown.Item>
                                        <Dropdown.Divider></Dropdown.Divider>
                                        <Dropdown.Item onClick={() => this.onSortChanged('name_asc')}
                                                       active={this.state.activeSort === 'name_asc'}>
                                            Nombre ascendente (A-Z)
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onSortChanged('name_desc')}
                                                       active={this.state.activeSort === 'name_desc'}>
                                            Nombre descendente (Z-A)
                                        </Dropdown.Item>
                                        <Dropdown.Divider></Dropdown.Divider>

                                        <Dropdown.Item onClick={() => this.onSortChanged('started_at_asc')}
                                                       active={this.state.activeSort === 'started_at_asc'}>
                                            Hora de inicio ascendente (AM-PM)
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onSortChanged('started_at_desc')}
                                                       active={this.state.activeSort === 'started_at_desc'}>
                                            Hora de inicio descendente (PM-AM)
                                        </Dropdown.Item>
                                        <Dropdown.Divider></Dropdown.Divider>
                                        <Dropdown.Item onClick={() => this.onSortChanged('finished_at_asc')}
                                                       active={this.state.activeSort === 'finished_at_asc'}>
                                            Hora de finalización ascendente (AM-PM)
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onSortChanged('finished_at_desc')}
                                                       active={this.state.activeSort === 'finished_at_desc'}>
                                            Hora de finalización descendente (PM-AM)
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Dropdown as={ButtonGroup}>
                                    <Dropdown.Toggle variant="complementary" id="dropdown-routes-status-filter">
                                        Estado
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => this.onStatusFilterChanged('')}
                                                       active={this.state.activeStatusFilter === ''}>
                                            Todas
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onStatusFilterChanged('open')}
                                                       active={this.state.activeStatusFilter === 'open'}>
                                            Abierta
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onStatusFilterChanged('on_route')}
                                                       active={this.state.activeStatusFilter === 'on_route'}>
                                            En ruta
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.onStatusFilterChanged('finished')}
                                                       active={this.state.activeStatusFilter === 'finished'}>
                                            Terminada
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/*Assigned operator*/}
                                <Dropdown as={ButtonGroup}>
                                    <Dropdown.Toggle variant="complementary" id="dropdown-routes-assigned-operator-filter">
                                        Operador &nbsp;
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item key={'operator_all'} className={'text-capitalize'}
                                                       onClick={() => this.onAssignOperatorChanged("")}
                                                       active={this.state.assignedOperator === ''}>
                                            Todos
                                        </Dropdown.Item>
                                        {
                                            operators.map(operator => {
                                                return (
                                                    <Dropdown.Item key={operator.uid} className={'text-capitalize'}
                                                                   onClick={() => this.onAssignOperatorChanged(operator.uid)}
                                                                   active={this.state.assignedOperator === operator.uid}>
                                                    {operator.name} {operator.last_name}
                                                    </Dropdown.Item>
                                            )}
                                        )}


                                    </Dropdown.Menu>
                                </Dropdown>
                            </ButtonGroup>
                        </ButtonToolbar>
                    </Col>
                </Row>

                <Row>
                    <NPIf condition={this.state.isLoading}>
                        <div className={'d-flex align-items-center justify-content-center'}>
                            <Spinner animation="grow" variant={"secondary"}/>
                        </div>
                        <NPElse>
                            <Col className='py-3' lg={16}>
                                <BootstrapTable keyField='_id'
                                                data={routes}
                                                columns={columns}
                                                noDataIndication={`No se encontraron rutas`}
                                                bordered={false}
                                />
                            </Col>
                            <NPPaginator numberOfPages={this.state.pages}
                                         onPageChanged={(p) => this.onPageChanged(p)}
                                         initialPage={this.state.currentPage}>
                            </NPPaginator>
                        </NPElse>
                    </NPIf>
                </Row>
            </Container>
        )
    }
}

export default withRouter(Routes);
